import React from "react";

import "./index.scss";
import {
  TableNullData,
  UserInformation,
} from "../../../../../../../../components";
import Context from "../../../../../../../../context";
import { useTranslation } from "react-i18next";
import convertNumberToPrice from "../../../../../../../../utils/convertNumberToPrice";
import convertGregorianToJalali from "../../../../../../../../utils/convertGregorianToJalali";

type Props = {
  data: any;
};

const Body = ({ data }: Props) => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const [openInfoModal, setOpenInfoModal] = React.useState<boolean>(false);
  const docs = data?.data?.result?.docs;
  const { requestApproveParentTransaction, setSelectedPayment, setShowModal } = React.useContext(
    Context.RejectedParentTransaction
  );

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // * =================================================================================================================
  // * -------------------------------------------- Start Local Functions ----------------------------------------------

  function onClickInfo() {
    setOpenInfoModal(!openInfoModal);
  }

  function onClickRow(index: number) {
    setSelectedPayment(index);
    setShowModal("SHOW_INFO");
  }

  // * --------------------------------------------- End Local Functions -----------------------------------------------
  // * =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  if (!docs || docs?.length <= 0) return <TableNullData />;
  return (
    <>
      <tbody id="find-transaction-body-container">
        {docs?.map((debt: any, index: number) => {
          return (
            <tr key={`files-tr-${index}`} onClick={() => onClickRow(index)}>
              <td onClick={onClickInfo}>
                <div className="table-index-number">
                  {requestApproveParentTransaction.page === 1
                    ? index + 1 : (requestApproveParentTransaction.page - 1) * 10 + index + 1}
                </div>
              </td>
              <td onClick={onClickInfo}>
                <UserInformation
                  name={debt?.parent?.firstName + " " + debt?.parent?.lastName}
                  phoneNumber={debt?.parent?.phoneNumber}
                  hideAvatar
                />
              </td>
              <td onClick={onClickInfo}>
                <UserInformation
                  avatar={debt?.student?.avatar}
                  name={debt?.student?.firstName + " " + debt?.student?.lastName}
                />
              </td>
              <td onClick={onClickInfo}>
                <UserInformation
                  avatar={debt?.driver?.avatar}
                  name={debt?.driver?.firstName + " " + debt?.driver?.lastName}
                  phoneNumber={debt?.driver?.phoneNumber}
                />
              </td>
              <td onClick={onClickInfo}>{convertNumberToPrice(debt?.price)} {"تومان"}</td>
              <td onClick={onClickInfo}>
                {convertGregorianToJalali({
                  date: debt?.updatedAt,
                  format: "hh:mm  jYYYY/jMM/jDD ",
                })}
              </td>
              <td onClick={onClickInfo} className="table-text">{debt?.isOnline ? "آنلاین" : "آفلاین"}</td>
            </tr>
          );
        })}
      </tbody>
    </>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================
};

export default Body;
